import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { DatePipe } from '@angular/common';

import { DriverEventRequest } from '../models/api/driver-event.request';
import { DriverEvent } from '../models/driver-event';
import { EnvironmentService } from 'src/app/services/environment.service';


@Injectable()
export class DriverEventsService {
    constructor(
        private httpClient: HttpClient,
        private datePipe: DatePipe,
        private environmentService: EnvironmentService
    ) { }

    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };

    /** @returns e.g. "2023-04-20T15:28:15.568+10:00" */
    private formatDate(date: Date): string | null {
        return this.datePipe.transform(date, 'yyyy-MM-ddTHH:mm:ss.SSSZZZZZ');
    }

    createDriverEvent(bookingId: string, publicId: string, driverEvent: DriverEvent): Observable<any> {
        console.log('createDriverEvent: REQUEST: ', bookingId, publicId, driverEvent);
        const eventDate = this.formatDate(new Date());
        if (eventDate) {
            const url = `${this.environmentService.getPublicApiUrl()}/v3/booking/${bookingId}/driver-events?publicId=${publicId}`;
            const payload: DriverEventRequest = {
                event_type: driverEvent.type,
                latitude: driverEvent.geolocation?.lat,
                location_accuracy: driverEvent.geolocation?.accuracy,
                longitude: driverEvent.geolocation?.lng,
                occurred_at: eventDate,
            };
            return this.httpClient
                .post(url, payload, this.httpOptions)
                .pipe(
                    map((res: any) => {
                        console.log('createDriverEvent: RESPONSE: ', res);
                        return res;
                    }),
                    catchError(this.handleError<DriverEventRequest>('createDriverEvent'))
                );
        } else {
            return of(new Error(`Can't define event date`));
        }
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (err: any): Observable<T> => {
            console.error(err);
            throw (err);
        };
    }

    isTooEarlyToAcceptDriverEvents(enableStartDate: Date | undefined): boolean {
        if (enableStartDate) {
            return Date.now() < enableStartDate.getTime();
        }
        return false;
    }   

    isTooLateToAcceptDriverEvents(enableEndDate: Date | undefined): boolean {
        if (enableEndDate) {
            return Date.now() > enableEndDate.getTime();
        }
        return false;
    }
}